// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LBNa","colMin":"styles_colMin__w_3hA"};